import BusinessApi from '@/api/Business'
import type { FetchParams, ParamType } from '@/api/types.ts'
import { queryOptions, useQuery } from '@tanstack/react-query'

export function useFetchBusiness(params: FetchParams) {
  return useQuery({
    queryKey: ['fetch-business', params],
    queryFn: () => BusinessApi.fetch([], params),
  })
}

export function getBusinessQueryOptions(id: ParamType) {
  return queryOptions({
    queryKey: ['get-business', id],
    queryFn: () => BusinessApi.get(id),
  })
}

export function useGetBusiness(id: ParamType) {
  return useQuery(getBusinessQueryOptions(id))
}
